import usePrivateAxios from "@/common/api/usePrivateAxios";
import { geosMap } from "@/common/constants/geosMap.constant";
import { useQueries } from "@tanstack/react-query";

export const useGeosOptions = (search: string) => {
  const privateAxios = usePrivateAxios()

  return useQueries({
    queries: geosMap.map((geo, index) => {
      return {
        queryKey: [geo.value, search],
        queryFn: () => privateAxios.get(`/geo/${geo.value}`, {
          params: {
            search
          }
        }),
        select: (data: any) => {
          return data?.data?.data.map((geo: any) => ({
            geo,
            geo_type: geosMap[index].type,
          }))
        }
      }
    }),
    combine: (result) => {
      return result.reduce((acc: any[], data) => {
        return acc.concat(data.data);
    }, []);
    }
  });
}
